<template>
  <div>
    <div v-show="isShow" class="mask" @touchmove.stop.prevent @click="handleClickMask"></div>
    <transition name="slide">
      <div v-show="isShow" class="fill-modal" @touchmove.stop.prevent>
        <div class="modal-container">
          <div class="modal-btns" v-if="hasBtn">
            <div class="modal-btn btn-confirm" @click="handleConfirm">确认</div>
            <div class="modal-btn btn-cancel" @click="handleCancel">取消</div>
          </div>
          <div class="modal-inner">
            <slot></slot>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  props: {
    isShow: Boolean,
    hasBtn: {
      type: Boolean,
      default: true,
    },
    maskClick: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    handleCancel() {
      this.$emit('update:isShow', false)
      this.$emit('cancel')
    },
    handleConfirm() {
      this.$emit('update:isShow', false)
      this.$emit('confirm')
    },
    handleClickMask() {
      if (this.maskClick) {
        this.handleCancel()
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.slide-enter-active {
  animation-name: slideInUp;
  animation-duration: 0.2s;
  animation-fill-mode: both;
}
.slide-leave-active {
  animation-name: slideOutDown;
  animation-duration: 0.2s;
  animation-fill-mode: both;
}
@keyframes slideInUp {
  0% {
    transform: translate3d(0, 100%, 0);
    visibility: visible;
  }

  to {
    transform: translateZ(0);
  }
}
@keyframes slideOutDown {
  0% {
    transform: translateZ(0);
  }

  to {
    visibility: hidden;
    transform: translate3d(0, 100%, 0);
  }
}

.delay-leave-active {
  animation-delay: 0.2s;
}

.fill-modal {
  background: #0c53f2;
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: auto;
  z-index: 10000;
}

.mask {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 9999;
  transition: all 0.2s ease-in;
}

.modal-container {
  padding-top: pxtow(52);
  .modal-btns {
    position: relative;
    display: flex;
    justify-content: space-around;
    .modal-btn {
      width: pxtow(209);
      height: pxtow(50);
      border: 1px solid #fd0fff;
      background-repeat: no-repeat;
      background-size: 100% 100%;
      font-size: pxtow(22);
      text-align: center;
      line-height: pxtow(50);
      font-weight: 700;
      &.btn-cancel {
        color: #fd0fff;
      }
      &.btn-confirm {
        background-color: #fd0fff;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/fundingnew/components/FillModal.vue